module.exports = __webpack_public_path__ + "img/unfavorite.94c41c32.svg";